import React, { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { OutboundFieldMapping } from '../../OutboundMappingSettings/OutboundFieldMapping'
import { MentionData } from '../../../../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { ContactLinking } from '../../ContactLinking/ContactLinking'

interface CustomSessionAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
  onChange?: () => void
}

export const CustomSessionAdminSettings: React.FC<CustomSessionAdminSettingsProps> = ({ serviceId, formKey = 0, onChange }) => {
  const sessionFieldMappingInputTokenOptions: MentionData[] = useMemo(() => {
    return [
      { id: 'meetingStartedAt', label: 'Meeting Started At', metadata: { type: 'date' } },
      { id: 'meetingFinishedAt', label: 'Meeting Finished At', metadata: { type: 'date' } },
      { id: 'title', label: 'Title', metadata: { type: 'string' } },
      { id: 'description', label: 'Description', metadata: { type: 'string' } },
      { id: 'descriptionPlainText', label: 'Description Plain Text', metadata: { type: 'string' } },
      { id: 'meetingTemplateId', label: 'Meeting Template Id', metadata: { type: 'string' } },
      { id: 'userExternalId', label: 'User External Id', metadata: { type: 'string' } },
      { id: 'roomId', label: 'Room Id', metadata: { type: 'string' } },
      { id: 'sessionId', label: 'Session Id', metadata: { type: 'string' } },
    ]
  }, [])

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <OutboundFieldMapping
            serviceId={serviceId}
            mappingKey='session'
            key={formKey}
            isUpdatable={true}
            inputTokenOptions={sessionFieldMappingInputTokenOptions}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <ContactLinking key={formKey} serviceId={serviceId} zocksObjectName={'Meeting Summary'} linkingKey='session' onChange={onChange} />
        </Col>
      </Row>
    </>
  )
}
